module.exports = __webpack_public_path__ + "img/暂无内容.796e541e.png";